<template>
  <div>
    <RebrandModal :show="showRebrand">
      <template slot="noWrapper">
        <div class="position-relative">
          <img
            src="https://uploads-ssl.webflow.com/642aae815b655125285e2266/6460d545880c8d81f0ad8f6d_loschen.svg"
            alt=""
            class="pop-up-rebrand-close-button"
            @click="handleShowRebrand(false)"
          />
          <img
            src="../assets/images/IMPORTANT NOTICE27 copy.jpg"
            alt=""
            class="rebrand-img"
          />
        </div>
      </template>
    </RebrandModal>
    <div class="page-wrapper">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        loader="bars"
      ></loading>
      <cookie-law theme="blood-orange--rounded"></cookie-law>

      <div class="container-fluid mt-1">
        <div
          v-if="profile.verification && profile.verification.status != true"
          class="alert alert-warning alert-dismissible fade show margin-bottom-1x"
        >
          <div style="display: flex" class="align-items-center">
            <div class="mr-3">
              <em class="font-24 icon-bell"></em>
            </div>
            <div>
              <h5 class="alert-close mb-0">{{ $t("alert") }}!</h5>
              <p class="alert-close mb-0">
                {{ $t("alert-content") }}
              </p>
            </div>
          </div>
        </div>
        <div class="mb-4 d-flex align-items-center">
          <span class="mr-2">Hi, {{ firstName }}</span>
          <IconWave />
        </div>
        <div class="row mb-3">
          <div class="col-lg-3 col-md-3">
            <router-link to="/devices">
              <div
                class="card scale-up"
                style="
                  height: 7.8rem;
                  border-radius: 16px;
                  background-color: rgba(158, 198, 221, 0.3);
                "
              >
                <div
                  class="card-body p-20 d-flex align-items-center justify-content-between flex-row-reverse"
                >
                  <div
                    class="icon-container icon-devices rounded-pill"
                    style="background: rgba(255, 255, 255, 0.5)"
                  >
                    <IconDevices />
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <p class="">{{ $t("devices") }}</p>
                    <h1 class="">{{ dashboard.devices }}</h1>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-lg-3 col-md-3">
            <router-link to="/groups">
              <div
                class="card scale-up"
                style="
                  height: 7.8rem;
                  border-radius: 16px;
                  background-color: rgba(143, 205, 159, 0.3);
                "
              >
                <div
                  class="card-body p-20 d-flex align-items-center justify-content-between flex-row-reverse"
                >
                  <div
                    class="icon-container icon-groups rounded-pill"
                    style="background: rgba(255, 255, 255, 0.5)"
                  >
                    <IconGroups />
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <p class="">{{ $t("groups") }}</p>
                    <h1 class="">{{ dashboard.groups }}</h1>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-lg-3 col-md-3">
            <router-link
              to="/users"
              :class="{ 'cursor-default': profile.role == 'staff' }"
            >
              <div
                class="card scale-up"
                style="
                  height: 7.8rem;
                  border-radius: 16px;
                  background-color: rgba(243, 201, 99, 0.3);
                "
              >
                <div
                  class="card-body p-20 d-flex align-items-center justify-content-between flex-row-reverse"
                >
                  <div
                    class="icon-container icon-users rounded-pill"
                    style="background: rgba(255, 255, 255, 0.5)"
                  >
                    <IconUsers />
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <p class="">{{ $t("users") }}</p>
                    <h1 class="">{{ dashboard.users }}</h1>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-lg-3 col-md-3">
            <router-link to="/devices">
              <div
                class="card scale-up"
                style="
                  height: 7.8rem;
                  border-radius: 16px;
                  background-color: rgba(244, 169, 169, 0.3);
                "
                @click="setCriticalCondition"
              >
                <div
                  class="card-body p-20 d-flex align-items-center justify-content-between flex-row-reverse"
                >
                  <div
                    class="icon-container icon-critical rounded-pill"
                    style="background: rgba(255, 255, 255, 0.5)"
                  >
                    <IconCritical />
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <p class="">{{ $t("critical") }}</p>
                    <h1 class="">{{ dashboard.criticals }}</h1>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row m-b-20">
          <div class="col-lg-9 col-md-8 col-sm-7 col-12">
            <div class="card" style="height: 100%">
              <div class="card-body">
                <div class="d-flex align-items-center col-gap-2">
                  <div
                    class="d-flex justify-content-space-around col-md-8 col-lg-6 mx-auto"
                    v-if="
                      singledevice &&
                      chartType === 'old' &&
                      (singledevice.type == 'mote' ||
                        singledevice.type == 'gps-vt')
                    "
                  >
                    <div class="btn-container">
                      <button
                        @click="showGraph('temp')"
                        :disabled="tempGraph == true"
                        id="graphselect"
                      >
                        {{ $t("temp") }}
                      </button>
                    </div>
                    <div class="btn-container">
                      <button
                        @click="showGraph('humi')"
                        :disabled="humiGraph == true"
                        id="graphselect"
                      >
                        {{ $t("humid") }}
                      </button>
                    </div>
                  </div>
                  <div class="d-flex align-items-baseline col-gap-1">
                    <div class="form-group">
                      <select
                        name="id"
                        class="form-control"
                        v-model="id"
                        @change="handleDeviceChange"
                      >
                        <option value="">--{{ $t("select") }}--</option>
                        <option
                          :key="device.id"
                          v-for="device in activedevices"
                          :value="device.id"
                        >
                          {{ device.settings.name }}
                        </option>
                      </select>
                    </div>

                    <router-link to="/devices">
                      <IconExpand />
                    </router-link>
                  </div>
                </div>
                <CombinedChart
                  :tempGraph="tempGraph"
                  :humiGraph="humiGraph"
                  :stats="devicehistoryChart"
                  :hasTemp2="hasTemp2"
                  v-if="chartType === 'old'"
                />
                <MultiAxisChart
                  :stats="devicehistoryChart"
                  v-if="chartType === 'new'"
                  :hasLight="hasLight"
                  :hasTemp2="hasTemp2"
                />
                <PaginationNew
                  :pageCount="pageCount"
                  :data="devicehistoryChart"
                  :sizeperpage="sizeperpage"
                  :pageNumber="pageNumber"
                  :pages="pages"
                  @goToLastPage="goToLastPage"
                  @nextPage="nextPage"
                  @handlePageChange="handlePageChange"
                  @goToFirstPage="goToFirstPage"
                  @prevPage="prevPage"
                  @onchange="onchange"
                  :rowOption="'chart'"
                  v-if="pageCount > 1"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-5 col-12" v-if="logs.length > 0">
            <div class="card" style="height: 100%; min-height: 500px">
              <div class="card-body">
                <!-- <AllDevicesMap :devices="mapdevices" /> -->
                <div
                  class="d-flex align-items-center justify-content-between mb-4 mt-1"
                >
                  <span class="font-weight-bold font-16">
                    {{ $t("audit_trail") }}
                  </span>
                  <router-link to="/logs" class="view-more">
                    {{ $t("view_more") }}
                    <ArrowForward />
                  </router-link>
                </div>
                <div class="block logs">
                  <div
                    v-for="(log, i) in logs.slice(0, 10)"
                    :key="`${i}`"
                    class="d-flex col-gap-1 mb-3"
                  >
                    <div class="audit-icon audit-success">
                      <IconAuditSuccess />
                      <!-- <IconAuditError
                        v-if="log.status.toLowerCase() === 'error'"
                      /> -->
                    </div>
                    <div class="">
                      <p class="mb-0" style="max-width: 23rem">
                        {{ log.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <NotificationsTable
                  :stats="deviceexcursions.data"
                  :paginationMeta="deviceexcursions.meta"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import introJs from "intro.js";
// import "intro.js/introjs.css";
import CookieLaw from "vue-cookie-law";
import IconDevices from "../components/Iconsvg/IconDevices";
import IconWave from "../components/Iconsvg/IconWave";
import IconUsers from "../components/Iconsvg/IconUsers";
import IconGroups from "../components/Iconsvg/IconGroups";
import IconCritical from "../components/Iconsvg/IconCritical";
import ArrowForward from "../components/Iconsvg/ArrowForward";
import IconAuditSuccess from "../components/Iconsvg/IconAuditSuccess";
import IconAuditError from "../components/Iconsvg/IconAuditError";
import IconExpand from "../components/Iconsvg/IconExpand";
import AllDevicesMap from "../components/Devices/AllDevicesMap";
import NotificationsTable from "../components/NotificationsTable";
import moment from "moment";
import RebrandModal from "../components/ModalContainer";
import tableMixinWithBackend from "../mixins/tableMixinWithBackend";
import PaginationNew from "../components/PaginationNew.vue";

export default {
  name: "Home",
  data() {
    return {
      isLoading: true,
      fullPage: true,
      mapdevices: [],
      activedevices: [],
      newFeatureModal: false,
      groupsIntro: false,
      tempGraph: true,
      humiGraph: false,
      id: "",
      period: { start: "", end: "" },
      paginationMetaData: [],
      devicehistoryChart: [],
      sizeperpage: 2000,
    };
  },
  components: {
    Loading,
    CookieLaw,
    IconDevices,
    IconUsers,
    IconGroups,
    IconCritical,
    MultiAxisChart: () =>
      import(/* webpackPrefetch: true */ "../components/Charts/MultiAxisChart"),
    CombinedChart: () =>
      import(/* webpackPrefetch: true */ "../components/Devices/CombinedChart"),
    NotificationsTable,
    RebrandModal,
    IconWave,
    ArrowForward,
    IconAuditSuccess,
    IconAuditError,
    IconExpand,
    PaginationNew,
  },
  mixins: [tableMixinWithBackend],
  mounted() {
    if (!this.seen) {
      this.newFeatureModal = true;
    }
    let date = new Date();
    date = moment(date).format("YYYY-MM-DD");
    this.period = {
      start: `${date.replace(/-/g, "/")} 00:00`,
      end: `${date.replace(/-/g, "/")} 23:59`,
    };
    this.showDashboard();
    this.handleGetLogs();
    this.fetchallDevices()
      .then(() => {
        this.activedevices = this.devices;
        if (this.profile.role == "staff") {
          this.activedevices = this.devices.filter(
            (device) =>
              (!device.users.length && device.settings.status == "public") ||
              device.users.includes(this.profile.id)
          );
        }
        if (this.activedevices.length > 0) {
          this.id = this.activedevices[0].id;
          const params = {
            device: this.singledevice.id,
            type: "device-alert",
            filterOperator: "and",
          };
          this.fetchDeviceDetails({ device_id: this.id })
            .then(() => {
              this.getChart();
            })
            .catch((err) => {
              console.error(err);
              this.isLoading = false;
            });

          this.fetchDeviceExcursions({
            params,
          });
        } else {
          this.isLoading = false;
        }
      })
      .catch((err) => {
        console.error(err);
        this.isLoading = false;
      });
  },
  computed: {
    ...mapGetters([
      "devices",
      "profile",
      "loginCount",
      "notifications",
      "sortednotifications",
      "dashboard",
      "singledevice",
      "features",
      "seen",
      "showRebrand",
      "logs",
      "deviceexcursions",
    ]),
    hasLight() {
      return this.singledevice?.hasLight || false;
    },
    hasTemp2() {
      return this.singledevice?.hasTemp2 || false;
    },
    chartType() {
      return this.profile?.company?.chartType || "old";
    },
    firstName() {
      return this.profile.fullname?.split(" ")[0];
    },
    chartStat() {
      if (!Array.isArray(this.singledevice?.stats)) {
        return [];
      }
      return [...this.singledevice.stats].reverse();
    },
    paginationMeta() {
      return this.paginationMetaData;
    },
  },
  methods: {
    ...mapActions([
      "fetchallDevices",
      "fetchProfile",
      "updateLogin",
      "fetchGroups",
      "getNotifications",
      "getSortedNotifications",
      "showDashboard",
      "fetchDeviceDetails",
      "updateFeature",
      "getFeatures",
      "seenPopUp",
      "handleShowRebrand",
      "getLogs",
      "fetchDeviceExcursions",
      "setCondition",
      "getDeviceHistoryChart",
    ]),
    handleGetLogs() {
      this.isLoading = true;
      this.getLogs({
        limit: 30,
        page: 1,
      })
        .then(() => {
          this.updateTable();
        })
        .then(() => {
          this.handleCsv();
        })
        .catch((error) => {
          // this.isLoading = false;
          this.Errormssg = error?.response?.data?.message;
        });
    },
    showGraph(type) {
      if (type == "temp") {
        this.tempGraph = true;
        this.humiGraph = false;
      }
      if (type == "humi") {
        this.humiGraph = true;
        this.tempGraph = false;
      }
    },
    closeNewFeatureModal() {
      this.newFeatureModal = false;
      this.seenPopUp();
    },
    handleDeviceChange() {
      this.isLoading = true;

      const params = {
        device: this.singledevice.id,
        type: "device-alert",
        filterOperator: "and",
      };
      if (this.id !== "") {
        this.fetchDeviceDetails({ device_id: this.id }).then(() => {
          this.getChart();
        });
        this.fetchDeviceExcursions({
          params,
        });
        let deviceInFocus = this.activedevices.filter(
          (device) => device.id === this.id
        );
        if (
          deviceInFocus[0].subscription[0] &&
          deviceInFocus[0].subscription[0].plan[0].features.location == true &&
          deviceInFocus[0].subscription[0].expired == false
        ) {
          this.mapdevices = deviceInFocus;
        } else {
          this.mapdevices = [];
        }

        this.getSortedNotifications({
          imei: deviceInFocus[0].imei,
          period: this.period,
        });
      } else {
        this.singledevice.stats = [];
        this.mapdevices = [];
        this.sortednotifications = [];
        this.isLoading = false;
      }
    },
    setCriticalCondition() {
      this.setCondition("critical");
    },
    getChart(chartLimit, chartPageNumber) {
      this.isLoading = true;
      let period = {
        device: this.id,
      };
      const chartSettings = this.profile.company.chartDateTimeSettings;
      const transmissionStartDate = {
        sortOrder: "ASC",
      };
      const chartParam =
        chartSettings === "transmissionStartDate" ? transmissionStartDate : "";
      this.getDeviceHistoryChart({
        period,
        params: {
          ...chartParam,
          filterOperator: "and",
          limit: chartLimit ?? this.sizeperpage,
          page: chartPageNumber ?? 1,
        },
      })
        .then((res) => {
          this.devicehistoryChart = res.data.payload.data;
          this.paginationMetaData = res.data.payload.meta;
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
    },
  },
  watch: {
    pageNumber() {
      this.getChart(this.sizeperpage, this.pageNumber);
    },
    sizeperpage() {
      this.getChart(this.sizeperpage, 1);
    },
  },
};
</script>

<style scoped src="../assets/css/dashboard/dashboard.css"></style>
<style scoped>
a {
  color: #404a57 !important;
}
.view-more {
  color: #213e7a !important;
}
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  width: 60px;
  height: 60px;
}
</style>
<style>
.icon-container svg path {
  stroke-width: 2;
}
.icon-devices svg path {
  stroke: #213e7a;
}
.icon-groups svg path {
  stroke: #213e7a;
}
.icon-users svg path {
  stroke: #213e7a;
}

.scale-up {
  transition: transform 0.8s ease-in-out;
}

.scale-up:hover {
  transform: scale(1.05);
}

.btn-container {
  display: flex;
  justify-content: center;
  width: 50%;
}
.pop-up-rebrand-close-button {
  width: 30px;
  opacity: 1;
  color: #fff;
  cursor: pointer;
  background-color: #25a74a;
  border-radius: 20px;
  padding: 5px;
  position: absolute;
  top: 20px;
  bottom: auto;
  left: auto;
  right: 20px;
}
.rebrand-img {
  height: 30rem;
}

.audit-icon {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.audit-success {
  background: #d9ffe3;
}
.audit-error {
  background: #ffe9e9;
}

@media (max-width: 590px) {
  .rebrand-img {
    height: 22rem;
  }
}

@media (max-width: 1250px) and (min-width: 820px) {
  .rebrand-img {
    height: 26rem;
  }
}

#graphselect {
  background-color: inherit;
  border: none;
  color: #213e7a;
  padding: 7px 25px;
  border-radius: 30px;
  outline: none;
}
#graphselect:hover {
  background-color: #213e7a;
  color: white;
}
#graphselect:disabled,
#graphselect[disabled] {
  background-color: #dee2eb;
  color: #213e7a;
}

.logs {
  height: 31rem;
  overflow-y: scroll;
}
</style>

<i18n>
{
	"en": {
		"alert": "Alert",
		"alert-content": "Email has not been verified. Check your mailbox for verification",
		"critical": "Critical Devices",
		"devices": "Devices",
		"groups": "Groups",
		"humid": "Humidity",
		"select": "Select Device",
		"staff": "staff",
		"temp": "Temperature",
		"users": "Users"
	},
	"es": {
		"alert": "Alerta",
		"alert-content": "No se ha verificado el correo electrónico. Revise su buzón de correo para verificar",
		"critical": "Dispositivos críticos",
		"devices": "Dispositivos",
		"groups": "Los grupos",
		"humid": "humedad",
		"select": "Seleccione el dispositivo",
		"staff": "Personal",
		"temp": "temperatura",
		"users": "Usuarios"
	},
	"fr": {
		"alert": "Alerte",
		"alert-content": "L'e-mail n'a pas été vérifié. Vérifiez votre boîte aux lettres pour vérification",
		"critical": "Périphériques critiques",
		"devices": "Dispositifs",
		"groups": "groupes",
		"humid": "Humidité",
		"select": "Choisir un appareil",
		"staff": "Personnel",
		"temp": "Température",
		"users": "utilisateurs"
	},
	"sw": {
		"alert": "Arifu",
		"alert-content": "Barua pepe haijathibitishwa. Angalia kisanduku chako cha barua kwa uthibitisho",
		"critical": "Vifaa Muhimu",
		"devices": "Vifaa",
		"groups": "Vikundi",
		"humid": "Unyevu",
		"select": "Chagua Kifaa",
		"staff": "STAFF",
		"temp": "Halijoto",
		"users": "Watumiaji"
	}
}
</i18n>
